import { render, staticRenderFns } from "./DeliveryTypeForm.vue?vue&type=template&id=7f679ecc&"
import script from "./DeliveryTypeForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports